// inputmask implementation
ht.declare('input.inputmask', function () {
  var inputmaskOpts = $(this).metadata().inputmaskOpts;
  if (inputmaskOpts) {
    $(this).inputmask(inputmaskOpts);
  }
});
